export default __webpack_public_path__ + "static/media/assign_team_members.e8f5c46a.png";